import React from "react";

// Marque HorsSignal — pointe/flèche vers le haut, fond transparent, couleurs de marque.
export default function LogoMark({ className = "h-7 w-auto", title = "HorsSignal" }) {
  return (
    <svg
      viewBox="0 0 100 118"
      className={className}
      role="img"
      aria-label={title}
      data-testid="logo-mark"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Grande pointe blanche avec entaille en chevron */}
      <path d="M50 6 L74 84 L50 60 L26 84 Z" fill="#F5F5F0" />
      {/* Chevron ocre */}
      <path d="M28 100 L50 74 L72 100 L50 88 Z" fill="#BC5D2E" />
    </svg>
  );
}
